export default "__VITE_ASSET__MhXAeVlL__"